import Logo from '@/components/Icons/Logo'
import Link from 'next/link'
import type { JSX } from 'react'

const LogoButton = (): JSX.Element => {
  return (
    <Link href="/" className="focus:outline-hidden">
      <Logo className="size-10 rounded-full bg-linear-to-br from-amber-400 to-orange-500 hover:from-amber-300 hover:to-orange-400" />
    </Link>
  )
}

export default LogoButton
